import { Dimmer } from 'semantic-ui-react';

import { useAppSelector } from '@store/hooks';
import { selectIsAnyModalActive } from '@store/modals.slice';

import s from './layout.scss'; // eslint-disable-line postcss-modules/no-unused-class

const ModalDimmer = () => {
  const isAnyModalActive = useAppSelector(selectIsAnyModalActive);

  return (
    <Dimmer active={isAnyModalActive} id="rootDimmer" className={s.dimmer} />
  );
};

export default ModalDimmer;
